import { render, staticRenderFns } from "./dashboard-registered.vue?vue&type=template&id=ca6ef606&scoped=true&"
import script from "./dashboard-registered.vue?vue&type=script&lang=js&"
export * from "./dashboard-registered.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-registered.vue?vue&type=style&index=0&id=ca6ef606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6ef606",
  null
  
)

export default component.exports